import { render, staticRenderFns } from "./FormUser.vue?vue&type=template&id=e6af9a4c"
import script from "./FormUser.vue?vue&type=script&lang=js"
export * from "./FormUser.vue?vue&type=script&lang=js"
import style0 from "./FormUser.vue?vue&type=style&index=0&id=e6af9a4c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports